import { createRouter } from "@tanstack/react-router";
import { RouterErrorComponent } from "./components/GlobalError";
import { GlobalLoadingSpinner } from "./components/GlobalLoadingSpinner";
import { NotFound } from "./components/NotFound";
import * as PostHog from "./integrations/posthog/root-provider";
import * as TanstackQuery from "./integrations/tanstack-query/root-provider";
import { routeTree } from "./routeTree.gen";

export type Router = ReturnType<typeof getRouter>;

declare module "@tanstack/react-router" {
	interface Register {
		router: Router;
	}
}

export const getRouter = () => {
	const rqContext = TanstackQuery.getContext();

	const router = createRouter({
		routeTree,
		context: { ...rqContext, authSession: null },
		defaultPreload: "intent",
		defaultPendingComponent: GlobalLoadingSpinner,
		defaultErrorComponent: RouterErrorComponent,
		defaultPendingMinMs: 200, // Avoid flash for fast loads
		defaultPendingMs: 100, // Show spinner after 100ms delay
		defaultNotFoundComponent: NotFound,
		Wrap: (props: { children: React.ReactNode }) => {
			return (
				<PostHog.Provider {...rqContext}>
					<TanstackQuery.Provider {...rqContext}>
						{props.children}
					</TanstackQuery.Provider>
				</PostHog.Provider>
			);
		},
	});

	return router;
};
